import { render, staticRenderFns } from "./xeBlankWidgetSetting.vue?vue&type=template&id=7255fba8&scoped=true"
import script from "./xeBlankWidgetSetting.vue?vue&type=script&lang=js"
export * from "./xeBlankWidgetSetting.vue?vue&type=script&lang=js"
import style0 from "./xeBlankWidgetSetting.vue?vue&type=style&index=0&id=7255fba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7255fba8",
  null
  
)

export default component.exports